import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class LangflowEmbedService {
  private scriptLoaded = false;

  readonly config = environment.langflow;

  get isScriptLoaded(): boolean {
    return this.scriptLoaded || !!document.querySelector('script[data-langflow-chat]');
  }

  loadScript(): Promise<void> {
    if (this.isScriptLoaded) {
      this.scriptLoaded = true;
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = this.config.scriptUrl;
      script.setAttribute('data-langflow-chat', 'true');
      script.onload = () => {
        this.scriptLoaded = true;
        resolve();
      };
      script.onerror = () => reject(new Error('Failed to load Langflow chat script'));
      document.body.appendChild(script);
    });
  }

  buildTweaks(components: Record<string, Record<string, unknown>>): string {
    return JSON.stringify(components);
  }

  buildCompanyGroupTweak(textInputId: string, companyGroupId: string): string {
    return this.buildTweaks({
      [textInputId]: { input_value: companyGroupId },
    });
  }
}
